export default {
  notPossible: 'Manuelle Bewegungen sind nicht möglich',
  executedConfirm: 'Wurde die Bewegung von "{source}" nach "{target}" ausgeführt?',
  command: {
    accept: 'Befehl annehmen',
    ack: 'Bestätigen',
  },
};
